import type { Brand } from "@borealis/layout-express";
import { type CountryCode, isValidPhoneNumber } from "libphonenumber-js";

export const validatePhone = (phone: string, brand: Brand): boolean => {
  const formattedBrand = brand.toLowerCase();
  const countryCodes: Record<"dba" | "finn" | "blocket", CountryCode> = {
    finn: "NO",
    blocket: "SE",
    dba: "DK",
  };

  const countryCode = countryCodes[formattedBrand as keyof typeof countryCodes];
  if (!countryCode) return false;

  return isValidPhoneNumber(phone, countryCode);
};
